import { Box, Divider, Skeleton, Stack } from "@mui/material";

function ListItemSkeleton() {
  return (
    <Stack direction="row" spacing={2}>
      <Box flexGrow={1}>
        <Stack spacing={2} direction={{ xs: "column", sm: "row" }}>
          <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} width={"20%"} />
          <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} width={"70%"} />
          <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} width={"10%"} />
        </Stack>
        <Stack
          color={"text.secondary"}
          direction="row"
          alignItems="center"
          gap={2}
        >
          <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"40%"} />
          <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"20%"} />
        </Stack>
      </Box>
      <Box flexGrow={2}>&nbsp;</Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <div>
          <Skeleton
            variant="rectangular"
            sx={{ fontSize: "2rem" }}
            width={70}
          />
        </div>
      </Box>
    </Stack>
  );
}

function NearMissListSkeleton() {
  return (
    <Stack
      component={"ul"}
      role="list"
      style={{ listStyleType: "none", padding: 0, margin: 0 }}
      spacing={1}
      divider={<Divider flexItem />}
    >
      <li>
        <ListItemSkeleton />
      </li>
      <li>
        <ListItemSkeleton />
      </li>
    </Stack>
  );
}

export default NearMissListSkeleton;
